import {FuseLoadable} from '@fuse';

export const HealthstatusConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/apps/readypayonline/Healthstatus',
            component: FuseLoadable({
                loader: () => import('../../dashboards/analytics/AnalyticsDashboardApp')
                //  i have commented out Healthstatus
            })
        },
      
       
      

    ]
};

